import RequestAction from "../../../common/states/actions.request";
import { ReceivableService } from "../../../data/VenueManagementService";

export const SET_RECEIVABLE_DATA = "SET_RECEIVABLE_DATA";
export const RESET_RECEIVABLE_DATA = "RESET_RECEIVABLE_DATA";
export const REQUEST_KEY_RECEIVABLE = "rk_receivable";


export const requestMonthlyReceivableData = (params) => async (dispatch) => {
    const { venueId , selectedMonth} = params; // add variables accordingly
    let [month, year] = selectedMonth.split("_")
    month = parseInt(month)
    console.log("try try",month, year);
    dispatch(
      RequestAction.setLoading({
        message: "Please wait while we populate Receivable",
        key: REQUEST_KEY_RECEIVABLE,
      })
    );
    
    try {
      const receivableResponse = await ReceivableService.getReceivableByMonth(
        { 
            venueId,
            month,
            year,
        } // add variables accordingly
      );
       
      dispatch({
        type: SET_RECEIVABLE_DATA,
        month: selectedMonth,
        receivableData: receivableResponse,
      });
      
      dispatch(
        RequestAction.setRequestState({
          key: REQUEST_KEY_RECEIVABLE,
          request_state: RequestAction.STATE.STAND_BY,
        })
      );
    } catch (err) {
      dispatch(
        RequestAction.setError({
          key: REQUEST_KEY_RECEIVABLE,
          error: JSON.parse(err?.message),
        })
      );
  
      console.error(
        "Error while getting receiable from Receivable Dashboard Service",
        err
      );
    }
  };
  
export const requestMonthStatement = (params) => async (dispatch) => {
  const { venueId , selectedMonth, downloadRef} = params; // add variables accordingly
  let [month, year] = selectedMonth.split("_")
  month = parseInt(month)
  console.log("try try again ",month, year);
  dispatch(
    RequestAction.setLoading({
      message: "Please wait while we populate Receivable",
      key: REQUEST_KEY_RECEIVABLE,
    })
  );
  
  try {
    const receivableResponse = await ReceivableService.getReceivableStatementByMonth(
      { 
          venueId,
          month,
          year,
          downloadRef
      } // add variables accordingly
    );
      
    // dispatch({
    //   type: SET_RECEIVABLE_DATA,
    //   month: selectedMonth,
    //   receivableData: receivableResponse,
    // });
    console.log(receivableResponse);
    dispatch(
      RequestAction.setRequestState({
        key: REQUEST_KEY_RECEIVABLE,
        request_state: RequestAction.STATE.STAND_BY,
      })
    );
  } catch (err) {
    dispatch(
      RequestAction.setError({
        key: REQUEST_KEY_RECEIVABLE,
        error: JSON.parse(err?.message),
      })
    );

    console.error(
      "Error while getting receiable from Receivable Dashboard Service",
      err
    );
  }
};